import { Cartao } from "../componentes/ui";
import { PoliticaDaOrganizacao } from "../componentes/acesso/PoliticaDaOrganizacao";
import { SegundoFatorDaConta } from "../componentes/acesso/SegundoFatorDaConta";
import { SessoesAbertas } from "../componentes/acesso/SessoesAbertas";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

/**
 * Segurança da conta: a verificação em duas etapas, as sessões abertas e — para quem administra a
 * organização — a política de acesso dela. A mesma tela nas duas áreas (`/app` e `/admin`): o
 * servidor decide o que cada pessoa pode ver e mudar.
 */
export function SegurancaDaConta() {
  useTitulo("Segurança da conta");
  const sessao = useSessao();
  const organizacaoId = sessao.data?.organizacao?.id ?? null;
  const gerenciaPolitica = podeNaSessao(sessao.data, "seguranca:gerenciar") && organizacaoId !== null;

  return (
    <div data-testid="seguranca-da-conta">
      <h1 className="titulo-pagina">Segurança da conta</h1>
      <p className="lead">
        Proteja o seu acesso com a verificação em duas etapas e acompanhe onde a sua conta está
        conectada.
      </p>

      <section className="secao-de-seguranca" aria-labelledby="titulo-segundo-fator">
        <h2 className="titulo-secao" id="titulo-segundo-fator">
          Verificação em duas etapas
        </h2>
        <Cartao>
          <SegundoFatorDaConta />
        </Cartao>
      </section>

      <section className="secao-de-seguranca" aria-labelledby="titulo-sessoes-da-conta">
        <h2 className="titulo-secao" id="titulo-sessoes-da-conta">
          Sessões abertas
        </h2>
        <p className="lead">
          Se algum dispositivo ou endereço não for seu, encerre a sessão dele — e troque a senha.
        </p>
        <SessoesAbertas dono={{ tipo: "minhas" }} />
      </section>

      {gerenciaPolitica && organizacaoId ? (
        <section className="secao-de-seguranca" aria-labelledby="titulo-politica-da-organizacao">
          <h2 className="titulo-secao" id="titulo-politica-da-organizacao">
            Política de acesso da organização
          </h2>
          <Cartao>
            <PoliticaDaOrganizacao organizacaoId={organizacaoId} />
          </Cartao>
        </section>
      ) : null}
    </div>
  );
}
